export default __webpack_public_path__ + "static/media/img-0060-usa-half-face.81d249eb.png";